module.exports = __webpack_public_path__ + "static/media/19-5.f5b24ffe.mp3";